import { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from '@mui/material/Button'

import CustomSelect from '../../Form/CustomSelect'
import ColorPicker from './ColorPicker'


export function Control( props )
{
    const name = props.name 
    return (
        <div style={{ width:'100%', height: '31px', fontSize:'12px', backgroundColor:'#FFF', marginBottom:'5px'}} >
            <div className="d-flex justify-content-start align-items-center" 
                 style={{ width: '130px', float: 'left', height:'100%' }} 
            >
                { name }
            </div>
            <div className="d-flex justify-content-start align-items-center" 
                 style={{ width:'calc( 100% - 130px )', height:'100%', float:'right' }}>
                { props.children } 
            </div>

        </div>
    )
}

export const StringInput = ( props ) =>
{
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue

    return (
        <Control name={name}>
            <Form.Control style={{ width:'100%'}} size="sm" 
                          value={value} 
                          onChange={ e => setValue( e.target.value )}
            />
        </Control>
    )
}

export const IntegerInput = ( props ) => 
{
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue

    return (
        <Control name={name}>
            <Form.Control style={{ width:'100%'}} size="sm" 
                          type="number"
                          step={1}
                          value={value} 
                          onChange={ e => setValue( parseInt(e.target.value) || 0 )}
            />
        </Control>
    )
}

export const PositiveIntegerInput = ( props ) => 
{
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue

    return (
        <Control name={name}>
            <Form.Control style={{ width:'100%'}} size="sm" 
                          type="number"
                          step={1}
                          value={value}
                          onChange={ e => setValue( Math.max( parseInt(e.target.value) || 0, 0 ) )}
            />
        </Control>
    )
}

export const FloatInput = (props) => {
    const name = props.name
    const value = props.value
    const setValue = props.setValue

    // Helper to format the number when the user leaves the field
    const handleBlur = (e) => {
        let val = parseFloat(e.target.value);
        
        // Handle empty or invalid inputs
        if (isNaN(val)) {
            setValue(0.00);
            return;
        }

        // Round to 2 decimal places and convert to string to preserve trailing zeros (e.g. "10.50")
        setValue(parseFloat(val.toFixed(2)));
    }

    return (
        <Control name={name}>
            <Form.Control 
                style={{ width: '100%' }} 
                size="sm"
                type="number"  // Adds up/down arrows and mobile keyboard
                step={0.05}    // Tells browser to allow decimals
                value={value}
                onChange={e => setValue(e.target.value)} // Update value as user types
                onBlur={handleBlur} // Format value when user leaves the field
            />
        </Control>
    )
}

export const SelectInput = (props) => {
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue 
    const options = props.options 

    return (
        <Control name={name}>
            <CustomSelect value={value}
                          onChange={(value) => setValue(value)}
                          options={options}
            />
        </Control>
    )
}

export const ColorInput = (props) => {
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue 

    return (
        <Control name={name}>
            <ColorPicker color={value} setColor={setValue} />
        </Control>
    )
}

export const VariableInput = ( props ) => {
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue 
    const type = props.type 

    return (
        <Control name={name}>
                <InputGroup size="sm">
                    <Form.Control value={value} 
                                  onChange={e => setValue(e.target.value)} 
                                  size="sm"  
                                 
                    />
                    <InputGroup.Text className="d-flex justify-content-center align-items-center" 
                                     style={{ width:'30px' }}>
                        {type}
                    </InputGroup.Text>
                </InputGroup>
        </Control>
    )
}

export const ButtonInput = ( props ) => {
    const name = props.name 
    const onClick = props.onClick

    return (
        <Control name="">
            <Button onClick={onClick} size="small" style={{ width:'100%', textTransform:'none'}}>
                {name}
            </Button>
        </Control>
    )
}


